<template lang="pug">
  .main-Layouts(v-if="company && member")
    y-dialog(v-model="newUpdate" persistent width="340" content-class="round-2xl")
      v-card.py-2.px-1
        v-card-title.text-lg.font-semibold(style="height:56px; justify-content: center;") {{ $t('latest_version_available') }}
        v-card-text.primary--text.pb-0
          .text-sm.mb-4.neutral500--text.text-center {{ $t('latest_version_available_desc') }}
        v-card-actions
          v-spacer
          y-button.ml-2(label="Close" color="white" @click='newUpdate = false' size="sm")
          //- y-button.ml-2(:label="$t('later')" color="white" text @click='newUpdate = false' size="sm")
          //- y-button(:label="$t('refresh_now')" @click="reload" size="sm" color="info")
    .admin-views
      app-top-bar
      v-container(v-if="isReloading")
        v-layout.my-6
          v-row.fill-height.ma-0(align='center' justify='center')
            div.text-center
              v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
              .s1.mt-4 {{ $t('refreshing') }}...
      router-view(v-else :company.sync="company" :menu.sync="menuOptions")
      .subscribe
        EmptySubscriptionModal(v-if="showSubscribeModal && !allowedPathAfterInactive" :open.sync="showSubscribeModal" :company="company")

</template>

<script>
import Vue from 'vue'
import { mapState, mapGetters, mapActions } from 'vuex'
import * as Sentry from '@sentry/vue'
import AppNavBar from '@/components/AppNavBar.vue'
import AppTopBar from '@/components/AppTopBar.vue'
import RegisterCard from '@/views/admin/billing/RegisterCard.vue'
import EmptySubscriptionModal from '@/components/billing/EmptySubscriptionModal.vue'
import Cookies from 'js-cookie'

Vue.mixin({
  methods: {
    async asyncForEach (array, callback) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
      }
    },
    Auth (type, id) {
      const permission = this.$store.state.permission
      if (type === 'root') {
        if (permission.root[id] != undefined) {
          return permission.root[id]
        }
      } else if (type === 'menu') {
        if (permission.side_menu[id] != undefined) {
          return permission.side_menu[id]
        }
      } else if (type === 'page') {
        if (permission.page_permissions[id]) {
          return permission.page_permissions[id].enter
        }
      } else if (type === 'component') {
        const path = id.split('#')[0]
        const component = id.split('#')[1]
        if (permission.page_permissions[path] && permission.page_permissions[path].components[component] != undefined) {
          return permission.page_permissions[path].components[component]
        }
      }
      return true
    }
  }
})

export default {
  name: 'AdminHome',
  components: {
    AppNavBar, AppTopBar, RegisterCard, EmptySubscriptionModal
  },
  data: () => ({
    isReloading: false,
    newUpdate: false,
    showSubscribeModal: false,
    showSendReminderDialog: false,
    showScheduleReminderDialog: false,
    isAtTop: false,
    menuOptions: {
      easyparcel_enabled: false,
      zepto_enabled: false,
      lalamove_enabled: false,
      woocommerce_enabled: false,
      shopify_enabled: false,
      mall_enabled: false,
      yezzapay_enable: false,
      pending_order_count: 0,
      unread_count: 0
    },
    offer1010Active: false,
    pStart: {x: 0, y:0},
    pStop: {x: 0, y:0},
    subscriptionPaymentCallback: null
  }),
  computed: {
    ...mapState('user', ['user', 'member', 'deviceId', 'walkThrough']),
    ...mapGetters({
      company: 'getCompany',
      currency: 'getCompanyCurrency'
    }),
    allowedPathAfterInactive () {
      const slashes = this.$route.path.toString().split('/')
      if (slashes.length > 3 && slashes[3].toString().includes('bills')) {
        return true
      } else if (slashes.length > 3 && slashes[3].toString().includes('subscription')) {
        return true
      } else if (slashes.length > 2 && slashes[2].toString().includes('notifications')) {
        return true
      }
      return false
    }
  },
  watch: {
    '$route.path' (val) {
      window.pageYOffset = 0
      document.documentElement.scrollTop = 0
      if (!this.Auth('page', val)) {
        this.$router.push('/admin/dashboard')
        return
      }
      if (val === '/admin/settings/advance' && this.Auth('page', '/admin/settings/advance-new')) {
        this.$router.push('/admin/settings/advance-new')
      }
    },
    '$store.state.ui.pendingOrderCount' (val) {
      this.menuOptions.pending_order_count = val
    },
    '$store.state.subscriptions.version' () {
      this.updateSubscriptions()
    }
  },
  mounted () {
    if (this.$route.path == '/admin' || this.$route.path == '/admin/') {
      this.$router.push('/admin/dashboard')
    }

    const cookieUser = Cookies.get('user')
    if (!cookieUser) {
      this.$store.commit('ui/setRedirectPath', this.$route.path)
      this.goToSignOut()
    }

    if (!this.user) {
      let user = JSON.parse(cookieUser)
      this.$store.commit('user/setUser', user)
    }

    Sentry.setUser({ 'id': this.user.id, 'email': this.user.email })
    this.fetchCompany()
    this.fetchNewFeatures()
    if (this.$isMobile) {
      window.addEventListener('touchstart', (e) => { this.swipeStart(e) }, false)
      window.addEventListener('touchend', (e) => { this.swipeEnd(e) }, false)
    }

    this.resetCurrency()
  },
  methods: {
    ...mapActions([
      'updateCompany', 'showMessage'
    ]),
    onIntersect (entries) {
      this.isAtTop = entries[0].isIntersecting
    },
    swipeStart (e) {
      if (typeof e['targetTouches'] !== "undefined"){
          var touch = e.targetTouches[0];
          this.pStart.x = touch.screenX;
          this.pStart.y = touch.screenY;
      } else {
          this.pStart.x = e.screenX;
          this.pStart.y = e.screenY;
      }
    },
    swipeEnd (e) {
      if (typeof e['changedTouches'] !== "undefined"){
          var touch = e.changedTouches[0];
          this.pStop.x = touch.screenX;
          this.pStop.y = touch.screenY;
      } else {
          this.pStop.x = e.screenX;
          this.pStop.y = e.screenY;
      }
      this.swipeCheck()
    },
    onRefresh () {
      if (this.isAtTop && !this.$store.state.ui.modalDialog.visible) {
        this.fetchSettingsMenu()
        this.isReloading  = true
        setTimeout(() => {
          this.isReloading  = false
        }, 500)
      }
    },
    swipeCheck () {
      var changeY = this.pStart.y - this.pStop.y;
      var changeX = this.pStart.x - this.pStop.x;
      if (this.isPullDown(changeY, changeX) ) {
        this.onRefresh()
      }
    },
    isPullDown (dY, dX) {
      // methods of checking slope, length, direction of line created by swipe action
      let minChangeRatio = 1.5
      if (this.$store.state.mobileapp.device && this.$store.state.mobileapp.device.platform === 'ios') {
        minChangeRatio = 2
      }
      return dY < 0 && (
          (Math.abs(dX) <= 100 && Math.abs(dY) >= 300/minChangeRatio)
          || (Math.abs(dX)/Math.abs(dY) <= 0.3 && dY >= 60/minChangeRatio)
      )
    },
    fetchCompany () {
      let url = `/companies/${this.$subdomain}/`
      let params = { use_slug: 'true' }
      if (!this.$subdomain) {
        url = `/companies/${this.company.id}/`
        params = {}
      }
      this.$axios.get(url, { params })
        .then(resp => {
          const latestCompany = resp.data
          this.updateCompany(latestCompany)
          this.setupWalkThrough()
          this.fetchMember()
          this.checkCreditReloadPayment()
          this.$store.commit('mobileapp/setCompanySlug', latestCompany.slug)
          this.resetCurrency()
          if (latestCompany.os === 'clinic') {
            this.fetchClinic(latestCompany.slug)
          }
        })
        .catch(() => {
          this.goToCompanyList()
        })
    },
    fetchMember () {
      this.$axios.get('/members/', { params: { user: this.user.id, company: this.company.id } })
        .then(resp => {
          if (resp.data.results.length === 0) {
            this.goToCompanyList()
          } else {
            this.$store.commit('user/setMember', resp.data.results[0])

            // Analytics
            if (this.deviceId) {
              this.$logEvent('company_session.started')
            }
          }
        })
        .catch(() => {})
        .finally(() => {
          this.fetchSettingsMenu()
        })
    },
    fetchClinic (slug) {
      this.$axios.get(`/clinics/${slug}?expand=form,company`)
        .then(resp => {
          this.$store.commit('clinic/setClinic', resp.data)
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data?.detail) {
            message = err.response.data.detail
          }
          this.showMessage(['error', message])
        })
    },
    goToSignOut () {
      if (this.$subdomain) {
        document.location.href = `https://${this.$subdomain}.${process.env.VUE_APP_BASE_DOMAIN}/signout`
      } else {
        this.$router.push('/signout')
      }
    },
    goToCompanyList () {
      this.$store.commit('ui/setRedirectPath', location.pathname + location.search)
      if (this.$subdomain) {
        document.location.href = `https://app.${process.env.VUE_APP_BASE_DOMAIN}/companies`
      } else {
        this.$router.push('/companies')
      }
    },
    reload () {
      location.reload()
    },
    updateSubscriptions () {

      this.$store.commit('subscriptions/startFetching')

      // Get member permissions
      this.$axios.get(`/members/${this.member.id}/permissions`)
      .then((response) => {
        const permissions = response.data
        this.$store.commit('permission/setPermissions', permissions)
        if (!this.Auth('page', this.$route.path)) {
          this.$router.push('/admin/dashboard').catch(() => null)
        }
        if (this.$route.path === '/admin/settings/advance' && this.Auth('page', '/admin/settings/advance-new')) {
          this.$router.push('/admin/settings/advance-new')
        }
        this.showSubscribeModal = this.Auth('root', 'account_suspended')
      },()=>{})

      // Get company subscriptions
      this.$axios.get(`/subscription/subscriptions/?company=${this.company.id}&terminated=false&ordering=start_date&expand=contract&page_size=1000`)
      .then((response) => {
        this.$store.commit('subscriptions/setSubscriptions', response.data.results)
        this.$store.commit('subscriptions/setDefaultFeature', this.company)
      },()=>{})

      // Get company genese
      this.$axios.get(`/companies/${this.company.id}/genes`)
      .then((response) => {
        this.$store.commit('subscriptions/setLimitations', response.data)
        this.$store.commit('subscriptions/setGenes', response.data)
      },()=>{})

    },
    fetchSettingsMenu () {
      if (!this.company) return

      this.updateSubscriptions()

      // Get shipping setting
      this.$axios.get(`/shipping/settings/${this.company.slug}`)
      .then((response) => {
        const settings = response.data
        this.menuOptions.easyparcel_enabled = settings.couriers.easyparcel.enabled
        this.menuOptions.zepto_enabled = settings.couriers.zepto.enabled
        this.menuOptions.lalamove_enabled = settings.couriers.lalamove.enabled
        const shipments = {
          easyparcel: settings.couriers.easyparcel.enabled,
          zepto: settings.couriers.zepto.enabled,
          lalamove: settings.couriers.lalamove.enabled,
          yscourier: settings.couriers.ys_courier.enabled,
          yslocaldelivery: settings.couriers.ys_localdelivery.enabled,
        }
        this.$store.commit('orders/setShipments', shipments)
      },()=>{})

      this.$axios.get(`/ecommerce/woocommerce/?company=${this.company.id}`).then((response) => {
        if (response.data.results.length != 0) {
          this.menuOptions.woocommerce_enabled = true
        }
      })
      .catch(() => {})

      this.$axios.get(`/ecommerce/shopify/?company=${this.company.id}`).then((response) => {
        if (response.data.results.length != 0) {
          this.menuOptions.shopify_enabled = true
        }
      })
      .catch(() => {})

      this.$axios.get(`/companies/${this.company.id}/allowed_payment_gateways/`).then((response) => {
        this.menuOptions.yezzapay_enable = response.data.yezzapay
      })
      .catch(() => {})

      // Notifications count
      const params = { page: 1, page_size: 1, form__company: this.company.id, status: 'processed', form_type_exclude: 'book_income' }
      if (this.member.role !== 'Admin') {
        params['member'] = this.member.id
      }
      this.$axios.get('/leads/', { params: params }).then((response) => {
        this.menuOptions.pending_order_count = response.data.count
        this.$store.commit('ui/setPendingOrderCount', response.data.count)
      }).catch(() => {})

      this.$axios.get(`/notifications/?member=${this.member.id}&read=false&&page_size=0`).then((response) => {
        this.menuOptions.unread_count = response.data.count
      }).catch(() => {})

    },
    fetchNewFeatures() {
      this.$axios.get('/news', { page_size: 1 })
        .then((response) => {
          // Get localstorage data
          const newFeatureLastRead = localStorage.getItem('new_feature_last_read')
          // When response is empty
          if (response.data.count === 0) {
            this.$store.commit('ui/setHasNewFeature', false)
          } else {
            // first time user without localstorage
            if (!newFeatureLastRead) {
              this.$store.commit('ui/setHasNewFeature', true)
            } else {
              // For user than already created localstorage
              const newFeatureLatestId = response.data.results[0].id
              const hasNewFeature = newFeatureLatestId > newFeatureLastRead
              this.$store.commit('ui/setHasNewFeature', hasNewFeature)
            }
          }
        })
        .catch(() => {})
    },
    async setupWalkThrough () {
      if ('walkthrough' in this.$route.query) {
        this.$store.commit('user/setWalkThrough', { step: 0, skipped: false })
        this.showMessage(['walk_through'])
        return
      } else if ('walkthrough_sales_page' in this.$route.query) {
        this.$store.commit('user/setWalkThroughLandingPage', { step: 0, skipped: false })
        this.showMessage(['walk_through_landing_page'])
        return
      } else if ('walkthrough_books' in this.$route.query) {
        this.$store.commit('user/setWalkThroughBooks', { step: 0, skipped: false })
        this.showMessage(['walk_through_books'])
        return
      }

      if ('donation' in this.$route.query) {
        this.$store.commit('user/setWalkThrough', { step: 0, skipped: false })
        this.showMessage(['walk_through_donation'])
        return
      }

      if (!this.walkThrough) {
        return
      }
      if (this.walkThrough.skipped) {
        if (this.walkThrough.skippedTs && (new Date() - new Date(this.walkThrough.skippedTs)) < 86400000) {
          return
        }
        const products = await this.$axios.get(`/products/?page_size=1&company=${this.company.id}`)
        const forms = await this.$axios.get(`/forms/?page_size=1&company=${this.company.id}`)
        if (products.data.count === 0 && forms.data.count === 0) {
          this.showMessage(['walk_through'])
        } else {
          this.$store.commit('user/setWalkThrough', null)
        }
      } else {
        this.showMessage(['walk_through'])
      }
    },
    checkCreditReloadPayment () {
      if (this.$route.query.status == 'prepaid_topup_payment_success' || this.$route.query.status == 'prepaid_topup_payment_failed') {
        const reminder = this.$store.state.reminder.data
        if (reminder && reminder.type === 'default') {
          this.showSendReminderDialog = true
        } else if (reminder && reminder.type === 'schedule') {
          this.showScheduleReminderDialog = true
        }
      }
    },
    resetCurrency () {
      if (this.currency.symbol != this.$currency.symbol) {
        Vue.prototype.$currency = this.currency
        this.reload()
      }
    }
  },
  wamp: {
    subscribe: {
      'new-update'() {
        this.newUpdate = true
      }
    }
  }
}
</script>

<style lang="scss">
</style>

<i18n>
{
  "en": {
    "latest_version_available": "Latest version is available",
    "latest_version_available_desc": "For your convenience, please refresh the page to prevent errors from happening",
    "later": "Later",
    "refresh_now": "Refresh Now",
    "refreshing": "Refreshing"
  },
  "id": {
    "latest_version_available": "Versi terbaru tersedia",
    "latest_version_available_desc": "Untuk kenyamanan kamu, harap segarkan halaman untuk mencegah kesalahan terjadi",
    "later": "Nanti",
    "refresh_now": "Segarkan sekarang",
    "refreshing": "Sedang disegarkan"
  }
}
</i18n>
